import uamStatusTypes from '../../consts/uam/uamStatusTypes';
import createAsyncRequestService from '../dam/asyncRequestService';
import uamClientService from './uamClientService';
import uamWebSocketResponseService from './uamWebSocketResponseService';

const uamAsyncRequestService = createAsyncRequestService({
    prefix: 'UAM',
    successStatus: uamStatusTypes.SUCCESS,
    failedStatus: uamStatusTypes.FAILED,
    pendingStatus: uamStatusTypes.PENDING,
    checkRequestStatus: async (dusn, requestId) => {
        const requestData = await uamClientService.getRequestStatus(dusn, requestId);

        const asyncMessage = {
            data: JSON.stringify({...requestData, serialNumber: dusn, isHttpMessage: true}),
        };

        uamWebSocketResponseService.proceedMessage(asyncMessage);
    },
});

export default uamAsyncRequestService;
